
import { useEffect, useRef, useState } from 'react';

export default function Problem() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup to avoid memory leaks
    return () => {
      try {
        observer.disconnect();
      } catch (e) {
        console.error('IntersectionObserver cleanup failed:', e);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#0B0D10] py-0">
      {/* Apple‑style full‑bleed visual with text overlay */}
      <div className="relative w-full h-[90vh] min-h-[700px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/3e65bebb056693470aa6de22cd02683f.jpg"
          alt="Premium AI Infrastructure"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B0D10] via-[#0B0D10]/80 to-transparent"></div>

        <div
          className={`absolute inset-0 flex items-center transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="max-w-7xl mx-auto px-6 w-full">
            <div className="max-w-xl">
              <p className="text-xs font-semibold tracking-[0.35em] text-[#8C9198] mb-6 uppercase">
                The Problem
              </p>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-white leading-[1.08] tracking-tight">
                Premium Brands Deserve Better Systems
              </h2>

              <p className="text-xl text-[#C5C9CF] mb-6 font-light leading-relaxed">
                Manual intake. Missed follow-ups. Disconnected CRMs. Lost high-value
                clients.
              </p>

              <p className="text-base text-[#8C9198] mb-8 font-light leading-relaxed">
                Most service businesses operate with outdated workflows that limit
                revenue, efficiency, and client experience.
              </p>

              <p className="text-lg text-white font-medium leading-relaxed">
                Deluxe AI Systems replaces chaos with structured, intelligent automation
                — engineered for growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
